import React, { useState } from "react";
import { useSearchBox, useInstantSearch } from "react-instantsearch";

const translations = {
  en: {
    submit: "Submit",
    reset: "Clear",
    placeholder: "Enter search term here...",
  },
  fr: {
    submit: "Valider",
    reset: "Effacer",
    placeholder: "Entrez le terme de recherche...",
  },
};

export default function CustomSearchBox({ inputRef, ...props }) {
  const { query, refine } = useSearchBox(props);
  const { status } = useInstantSearch();
  const [inputValue, setInputValue] = useState(query);
  const lang = document.documentElement.lang || "en";
  const t = translations[lang] || translations.en;

  const isSearchStalled = status === "stalled";

  function setQuery(newQuery) {
    setInputValue(newQuery);

    refine(newQuery);
  }

  return (
    <form
      className="search-box-form"
      action=""
      role="search"
      noValidate
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();

        if (inputRef.current) {
          inputRef.current.blur();
        }
      }}
      onReset={(event) => {
        event.preventDefault();
        event.stopPropagation();

        setQuery("");

        if (inputRef.current) {
          inputRef.current.focus();
        }
      }}
    >
      <input
        ref={inputRef}
        placeholder={t.placeholder}
        aria-describedby="search-info"
        className="search-input h5"
        spellCheck={false}
        maxLength={512}
        type="search"
        value={inputValue}
        onChange={(event) => {
          setQuery(event.currentTarget.value);
        }}
        autoFocus
      />
      <button className="search-box-submit" type="submit">
        {t.submit}
      </button>
      <button
        className="search-box-reset"
        type="reset"
        hidden={inputValue.length === 0 || isSearchStalled}
        aria-label={t.reset}
      >
        <span aria-hidden="true" className="search-box-reset-label">
          {t.reset}
        </span>
        <svg
          width="16"
          height="16"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="264.8 264.8 494.4 494.4"
          fill="none"
        >
          <path
            stroke="#293a3a"
            fill="#293a3a"
            d="M697.4 759.2l61.8-61.8L573.8 512l185.4-185.4-61.8-61.8L512 450.2 326.6 264.8l-61.8 61.8L450.2 512 264.8 697.4l61.8 61.8L512 573.8z"
          />
        </svg>
      </button>
    </form>
  );
}
